"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var HelpAndFaqComponent = /** @class */ (function () {
    function HelpAndFaqComponent() {
    }
    HelpAndFaqComponent.prototype.ngOnInit = function () {
    };
    return HelpAndFaqComponent;
}());
exports.HelpAndFaqComponent = HelpAndFaqComponent;
